(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);



// ------------------------------------------------------------------------------------------------------------------------------------
// Touch
// ------------------------------------------------------------------------------------------------------------------------------------

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}



// ------------------------------------------------------------------------------------------------------------------------------------
// Menu hover
// ------------------------------------------------------------------------------------------------------------------------------------

/*
if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details:not(.shop-by-brand):not(.links)");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 100);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}
*/

// Menu Expand
/*
document.querySelectorAll(".header__subdropdown > div > ul > li").forEach(function(element){
  element.addEventListener("click", function(event){

    //console.log('test')

    document.querySelectorAll(".header__subdropdown > div > ul > li details:not(.shop-by-brand):not(.links)").forEach(function(element){
      element.removeAttribute("open");
    });

  });
});
*/


// ------------------------------------------------------------------------------------------------------------------------------------
// Sticky Header
// ------------------------------------------------------------------------------------------------------------------------------------
/*  
var topBar = document.querySelector('.top-bar');
var topBarHeight = topBar.offsetHeight;
var headerHeight = document.querySelector('.header-wrapper').offsetHeight;
var totalHeight = topBarHeight + headerHeight + 50;

let headerCart = document.querySelector('.header__icon--cart');
let headerAccount = document.querySelector('.header__icon--account');
let topBarLinks = document.querySelector('.top-bar-links');
let headerIcons = document.querySelector('.header__icons');
  
var stickyHeader = function(){

  var scrollTop = window.scrollY;

  if (scrollTop > totalHeight ) {
      topBar.classList.add('opacity');
      setTimeout(() => {
        topBar.classList.remove('opacity');
        topBar.classList.add('sticky');
        document.getElementsByTagName("body")[0].style.paddingTop = topBarHeight+'px';

        if ( topBarLinks && headerCart && headerAccount && window.innerWidth > 749 ){
          // Move stuff
          topBarLinks.append(headerAccount);
          topBarLinks.append(headerCart);
        }
      }, "150");
  } else {
      setTimeout(() => {
        topBar.classList.remove('sticky');
        document.getElementsByTagName("body")[0].style.paddingTop = 0;

        if ( headerIcons && headerCart && headerAccount && window.innerWidth > 749 ){
          // Move stuff back
          headerIcons.prepend(headerCart);
          headerIcons.prepend(headerAccount);
        }

      }, "150");
  }

};

stickyHeader();
// and run it again every time you scroll
window.onscroll = function() {
  stickyHeader();
};
*/


// ------------------------------------------------------------------------------------------------------------------------------------
// Cart Pop up
// ------------------------------------------------------------------------------------------------------------------------------------

let windowWidth = window.innerWidth;
let cartDrawer = document.querySelector('cart-drawer.drawer');
let headerIconCart = document.querySelector('.header__icon--cart');

if ( windowWidth > 749 ){ 
  // Move stuff
  headerIconCart.append(cartDrawer);
}



// ------------------------------------------------------------------------------------------------------------------------------------
// Account Pop up
// ------------------------------------------------------------------------------------------------------------------------------------
/*
var bodyTag = document.getElementsByTagName("body")[0];
var accountPopup = document.getElementById("account-popover");

document.querySelector(".header__icon--account > a.link").addEventListener("click", function(event) {
  event.preventDefault();
  event.stopPropagation();
  cartDrawer.classList.remove("active");
  
  var getAttr = accountPopup.getAttribute("aria-hidden");

  if ( getAttr == "true" ) {
    accountPopup.setAttribute("aria-hidden", "false");
    bodyTag.classList.add("overflow");
  } else{
    accountPopup.setAttribute("aria-hidden", "true");
    bodyTag.classList.remove("overflow");
  }

});

bodyTag.addEventListener("click", function(event) {
  accountPopup.setAttribute("aria-hidden", "true");
  cartDrawer.classList.remove("active");
  bodyTag.classList.remove("overflow");
  //bodyTag.classList.remove("overflow-hidden");
});
accountPopup.addEventListener("click", function(event) {
  event.stopPropagation();
});
cartDrawer.addEventListener("click", function(event) {
  event.stopPropagation();
});
document.querySelector(".account__close").addEventListener("click", function(event) {
  accountPopup.setAttribute("aria-hidden", "true");
  bodyTag.classList.remove("overflow");
});

// Account Pop up slides

var loginPanel = document.getElementById("header-login-panel");
var registerPanel = document.getElementById("header-register-panel");
var recoverPanel = document.getElementById("header-recover-panel");
var popoverPanelList = document.querySelector(".popover__panel-list");

if ( document.querySelector("#header-login-panel [aria-controls='header-register-panel']") ){
  document.querySelector("#header-login-panel [aria-controls='header-register-panel']").addEventListener("click", function(event) {
    loginPanel.classList.remove("is-selected");
    registerPanel.classList.add("is-selected");

    let panelHeight = registerPanel.offsetHeight;
    popoverPanelList.style.height = panelHeight+'px';
  });
}

if ( document.querySelector("#header-login-panel [aria-controls='header-recover-panel']") ){
  document.querySelector("#header-login-panel [aria-controls='header-recover-panel']").addEventListener("click", function(event) {
    loginPanel.classList.remove("is-selected");
    recoverPanel.classList.add("is-selected");

    let panelHeight = recoverPanel.offsetHeight;
    popoverPanelList.style.height = panelHeight+'px';
  });
}

if ( document.querySelector("#header-register-panel [aria-controls='header-login-panel']") ){
  document.querySelector("#header-register-panel [aria-controls='header-login-panel']").addEventListener("click", function(event) {
    registerPanel.classList.remove("is-selected");
    loginPanel.classList.add("is-selected");

    popoverPanelList.removeAttribute('style');
  });
}

if ( document.querySelector("#header-recover-panel [aria-controls='header-login-panel']") ){
  document.querySelector("#header-recover-panel [aria-controls='header-login-panel']").addEventListener("click", function(event) {
    recoverPanel.classList.remove("is-selected");
    loginPanel.classList.add("is-selected");
    
    popoverPanelList.removeAttribute('style');
  });
}
*/

// ------------------------------------------------------------------------------------------------------------------------------------
// Add Vat Number Pop up
// ------------------------------------------------------------------------------------------------------------------------------------

ready('#cart-page-vat-form .sufio-vat-link', function(element) {

  // Create a new element
  const div = document.createElement('div');

  // Modify it
  div.innerHTML = '<span class="svg-wrapper"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Vector" d="M12 11V16M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12.0498 8V8.1L11.9502 8.1002V8H12.0498Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span><div class="content">' + window.themeStrings.taxExempt + '</div>';
  div.className = 'pop-up';

  // Select the parent element
  const container = element;

  // Append the new element
  container.after(div);

  element.click();

});

// ------------------------------------------------------------------------------------------------------------------------------------
// Related Slider
// ------------------------------------------------------------------------------------------------------------------------------------

/*
ready('#related-product-grid .grid__item', function(element) {
  var relatedSlider = document.getElementById('related-product-grid');
  if ( relatedSlider ){
    var flkty = new Flickity( relatedSlider, {
      // options
      groupCells: true,
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      pauseAutoPlayOnHover: false
    });
  }
});*/



// ------------------------------------------------------------------------------------------------------------------------------------
// USP Slider 
// ------------------------------------------------------------------------------------------------------------------------------------

var uspSlider = document.querySelectorAll('.usp-wrapper');
if ( uspSlider ){
  uspSlider.forEach(slider => {
    var flkty = new Flickity( slider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 3000,
      watchCSS: true,
      pauseAutoPlayOnHover: false
    });
  });
}



// ------------------------------------------------------------------------------------------------------------------------------------
// Move Collection Details
// ------------------------------------------------------------------------------------------------------------------------------------

let collectionDetails = document.querySelector('.collection-details-wrapper');
let facetsWrapper = document.querySelector('.facets-wrapper');
let productGrid = document.querySelector('.product-grid-wrapper');


window.addEventListener("resize", (event) => {
  if ( collectionDetails ) {
    if ( window.innerWidth < 990 ) {
      facetsWrapper.before(collectionDetails);
      facetsWrapper.classList.add("show");
    } else {
      productGrid.prepend(collectionDetails);
    }
  }
});


if ( collectionDetails && window.innerWidth < 990 ) {
  facetsWrapper.before(collectionDetails);
}
if ( productGrid && window.innerWidth < 990 ) {
  facetsWrapper.classList.add("show");
}



// ------------------------------------------------------------------------------------------------------------------------------------
// Move Volume Discount 
// ------------------------------------------------------------------------------------------------------------------------------------

/*
ready('.product__info-container #wsaio-volume-discount--table', function(element) {
  
  let volumeTable = document.querySelector('.product__info-container #wsaio-volume-discount--table');
  let productCustomCol = document.querySelector('.product__custom-wrapper');

  productCustomCol.prepend(volumeTable);
  //iconsWithText.after(volumeTable);


  const para = document.createElement("div");
  para.innerHTML = "<span>For larger quantities and discounts</span> <a href='/pages/contact'>Contact us</a>";
  para.classList.add('volume-contact');
  volumeTable.after(para);
 

});
*/



// ------------------------------------------------------------------------------------------------------------------------------------
// Product Page Trade Price
// ------------------------------------------------------------------------------------------------------------------------------------

function tradePrices() {

  //if ( document.querySelector('.prod_d .price.wsdapp .price__sale .price-item--sale .money') ) {
  if ( document.querySelector('.price-group .price.wsdapp .price__sale .price-item--regular .money') ) {
    console.log('Trade prices change');

    //var tradePrice = document.querySelector('.prod_d .price.wsdapp .price__sale .price-item--sale .money').innerHTML.trim().replace('€','').replace(',','.');
    //var originalPrice = document.querySelector('.prod_d .price.wsdapp .price__sale .price-item--regular .money').innerHTML.trim().replace('€','').replace(',','.');

    var tradePrice = document.querySelector('.price-group .price__sale .price-item--sale .money').innerHTML.trim().replace('€','').replace(',','.');
    var originalPrice = document.querySelector('.price-group .price__sale .price-item--regular .money').innerHTML.trim().replace('€','').replace(',','.');

    var percentageDiscount = ((originalPrice - tradePrice) / (originalPrice)) * 100;

    var tablePrices = document.querySelectorAll('td.cell-price');

    tablePrices.forEach(function(element) {

      var cellPrice = element.innerHTML.trim().replace('€','').replace(',','.');
      var calcCellPrice = (cellPrice/100) * percentageDiscount;
      var newCellPrice = (cellPrice - calcCellPrice).toFixed(2).replace('.',',');

      //console.log(newCellPrice);

      element.innerHTML = '€' + newCellPrice;

    })

  }

}

// Select the target node.
var tradePriceChange = document.querySelector('.price-group > .price');

if ( tradePriceChange ) {
    // Create an observer instance.
    var observertradePrice = new MutationObserver(function(mutations) {
      //console.log('Trade prices change');
      tradePrices();
      observertradePrice.disconnect();
    });
    // Pass in the target node, as well as the observer options.
    observertradePrice.observe(tradePriceChange, {
      attributes:    true,
      //characterData: true,
      //childList:     true
    });
}


// ------------------------------------------------------------------------------------------------------------------------------------
// Volume Discount Contact
// ------------------------------------------------------------------------------------------------------------------------------------

ready('#wsaio-volume-discount--table', function(element) {


  let volumeTable = document.querySelector('#wsaio-volume-discount--table');
  let productCustomCol = document.querySelector('.product__custom-wrapper');

  productCustomCol.prepend(volumeTable);

  let volumeContact = document.querySelector('.volume-contact');
  if ( volumeContact ) {
    volumeContact.remove();
  }
  
  //let volumeTable = document.querySelector('#wsaio-volume-discount--table');

  const para = document.createElement("div");
  para.innerHTML = "<span>"+window.themeStrings.volumeDiscountText+"</span> <a href='/pages/contact'>"+window.themeStrings.volumeDiscountLink+"</a>";
  para.classList.add('volume-contact');
  volumeTable.after(para);

});


// ------------------------------------------------------------------------------------------------------------------------------------
// Move back order text
// ------------------------------------------------------------------------------------------------------------------------------------

ready('.restock-rocket-preorder-description', function(element) {

  let restockText = document.querySelector('.restock-rocket-preorder-description');
  let buyButtonsEl = document.querySelector('.buy-buttons');

  buyButtonsEl.after(restockText);

});


// ------------------------------------------------------------------------------------------------------------------------------------
// Change table prices on quantity input
// ------------------------------------------------------------------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {

  function parsePrice(text) {
    let value = text.replace(/[^\d.,-]/g, '');

    if (value.includes('.') && value.includes(',')) {
      if (value.lastIndexOf('.') > value.lastIndexOf(',')) {
        value = value.replace(/,/g, '');
      } else {
        value = value.replace(/\./g, '').replace(',', '.');
      }
    } else if (value.includes(',')) {
      const parts = value.split(',');
      if (parts[1] && parts[1].length <= 2) {
        value = value.replace(',', '.');
      } else {
        value = value.replace(/,/g, '');
      }
    } else if (value.includes('.')) {
      const parts = value.split('.');
      if (!(parts[1] && parts[1].length <= 2)) {
        value = value.replace(/\./g, '');
      }
    }

    return parseFloat(value) || 0;
  }

  function extractCurrencyInfo(text) {
    const trimmed = text.trim();
    const currency = trimmed.replace(/[0-9.,\s]/g, '').trim();
    const isPrefix = trimmed.startsWith(currency);
    return { currency, isPrefix };
  }

  function detectDecimals(text) {
    const match = text.match(/[.,](\d+)/);
    return match ? match[1].length : 0;
  }

  function detectDecimalSeparator(text) {
    const match = text.match(/[.,](\d+)/);
    return match ? match[0][0] : '.';
  }

  function formatPrice(value, decimals, separator) {
    let out = value.toFixed(decimals);
    if (separator === ',') out = out.replace('.', ',');
    return out;
  }

  function getVolumeDiscounts() {
    const rows = document.querySelectorAll('#wsaio-volume-discount--table tbody tr');
    const discounts = [];

    rows.forEach(row => {
      const qtyText = row.querySelector('td:first-child')?.innerText.trim();
      const discountText = row.querySelector('td:last-child')?.innerText.trim();

      if (!qtyText || !discountText) return;

      discounts.push({
        quantity: parseInt(qtyText.replace('Buy ', ''), 10),
        discount: parseFloat(discountText.replace('% Off', '')) / 100
      });
    });

    discounts.sort((a, b) => a.quantity - b.quantity);
    return discounts;
  }

  function updatePrice(row) {
    const input = row.querySelector('.quantity-input');
    if (!input) return;

    const quantity = parseInt(input.value, 10) || 0;
    const priceCell = row.querySelector('.cell-price');
    if (!priceCell) return;

    let { basePrice, currency, isPrefix, decimals, decimalSeparator } = priceCell.dataset;

    if (basePrice === undefined) {
      basePrice = parsePrice(priceCell.innerText);

      const info = extractCurrencyInfo(priceCell.innerText);
      currency = info.currency;
      isPrefix = info.isPrefix;
      decimals = detectDecimals(priceCell.innerText);
      decimalSeparator = detectDecimalSeparator(priceCell.innerText);

      priceCell.dataset.basePrice = basePrice;
      priceCell.dataset.currency = currency;
      priceCell.dataset.isPrefix = isPrefix;
      priceCell.dataset.decimals = decimals;
      priceCell.dataset.decimalSeparator = decimalSeparator;
    } else {
      basePrice = parseFloat(basePrice);
      decimals = parseInt(decimals, 10);
      isPrefix = isPrefix === "true";
    }

    let total;

    if (document.getElementById('wsaio-volume-discount--table')) {
      const discounts = getVolumeDiscounts();
      let applicable = 0;

      for (const d of discounts) {
        if (quantity >= d.quantity) applicable = d.discount;
      }

      const discountedUnit = Number((basePrice * (1 - applicable)).toFixed(decimals));
      total = formatPrice(discountedUnit * quantity, decimals, decimalSeparator);
    } else {
      total = formatPrice(basePrice * quantity, decimals, decimalSeparator);
    }

    priceCell.innerText = isPrefix ? `${currency}${total}` : `${total} ${currency}`;
  }

  const variantTable = document.querySelector('.product-variants table tbody');

  if (variantTable) {
    variantTable.addEventListener('input', e => {
      if (e.target.classList.contains('quantity-input')) {
        updatePrice(e.target.closest('tr'));
      }
    });
  }

});


// ------------------------------------------------------------------------------------------------------------------------------------
// Scroll Up
// ------------------------------------------------------------------------------------------------------------------------------------

var scrollTopBtn = document.getElementById('scroll-top');

if ( window.scrollY > 0 ){
  scrollTopBtn.classList.remove('hide');
}

scrollTopBtn.addEventListener("click", function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(function(){
    scrollTopBtn.classList.add('hide');
  }, 500);
});


var scrollableElement = window;

scrollableElement.addEventListener('scroll', checkScroll);

function checkScroll(event) {
    console.log('scroll');
    scrollTopBtn.classList.remove('hide');

    if ( window.scrollY === 0 ){
      scrollTopBtn.classList.add('hide');
    }
}